import React, {useContext, useState} from 'react';
import CardButton from "./CardButton";
import {Divider} from "antd";
import QuickActivityReportWrapper from "./QuickActivityReportWrapper";
import { useLocation } from "wouter";
import {
    GradingRounded,
    Groups2Rounded,
    InsertChartOutlinedRounded,
} from "@mui/icons-material";
import {BrandContext} from "@context/BrandContext";

const ReportsHome = () => {

    const [location, navigate] = useLocation();
    const brandConfig = useContext(BrandContext);

    return (
        <div className={'ch-reports-home'}>
            <h2 id="report-types-heading">Get started</h2>
            <div
                className={'ch-reports-home-button-wrapper'}
                role="region"
                aria-labelledby="report-types-heading"
                aria-roledescription="carousel"
            >
                <CardButton
                    onClickFn={() => navigate('/web/ui/view/reports/activityReport')}
                    cardTitle={'Activity reports'}
                    cardIcon={<InsertChartOutlinedRounded fontSize={"large"} />}
                />
                <CardButton
                    onClickFn={() => navigate('/web/ui/view/reports/studentReport')}
                    cardTitle={'Student reports'}
                    cardIcon={<Groups2Rounded fontSize={"large"} />}
                />
            </div>
            <Divider />
            <h2>Quick activity reports</h2>
            <QuickActivityReportWrapper />
        </div>
    );
};

export default ReportsHome;
